import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { SettingService } from './setting.service';
import { ApiControllerService } from './api-controller.service';

export interface IPartialAddress {
  postalCode: string;
  city: string;
  provinceCode: string;
  streetDirectionCode: string;
  streetName: string;
  streetTypeCode: string;
}

export interface IAddressRange {
  city: string;
  provinceCode: string;
  streetDirectionCode: string;
  streetName: string;
  streetTypeCode: string;
}

export interface IAddress {
  postalCode: string;
  city: string;
  province: string;
  streetDirection: string;
  streetDirectory: string;
  street: string;
  streetType: string;
  streetNumber: string;
  suiteNumber: string;
  country?: string;
}

@Injectable({
  providedIn: 'root'
})
export class AddressService {

  constructor(private http: HttpClient, 
    private setting: SettingService,
    private apiController: ApiControllerService) { }

  findByPostalCode(postalCode: string) : Observable<IAddressRange[]> {
    return Observable.create(o => {
      /* let o$ = this.http.post(this.setting.getSmaUrl('/api/Geo/GetStreetsFromPostalCode'), { 
        postalCode: postalCode 
      }); */
      let o$ = this.apiController.post(this.setting.getSmaUrl('/api/Geo/GetStreetsFromPostalCode'), { 
        postalCode: postalCode 
      });

      o$
        .pipe(finalize(() => {
          o.complete();
        }))
        .subscribe(
          r => o.next(r),
          r => {
            o.error(r);
          }
        );
    });
  }

  validate(model: IAddress): Observable<boolean> {
    return Observable.create(o => {
      // validate address.
      //let o$ = this.http.post(this.setting.getSmaUrl('api/Geo/ValidateAddress'), model);
      let o$ = this.apiController.post(this.setting.getSmaUrl('api/Geo/ValidateAddress'), model);

      o$
        .pipe(finalize(() => {
          o.complete();
        }))
        .subscribe(
          (result) => o.next(result),
          r => {
            if (r.status != 400)
            o.error(r);
          }
        );
    });
  }
}
